import { styleEffect } from "framer-motion";
import React, { useState } from "react";
import styles from "./LeadNurturing.module.css";
import illustration from "../../Images/image4.jpg";
import ilustration1 from "../../Images/image5.png";
import ilustration2 from "../../Images/candidateoutreactimage2.png";
import ilustration3 from "../../Images/image6.png";
import ilustration4 from "../../Images/image7.jpeg";





const LeadNurturing = () => {
    const [activeIndex, setActiveIndex] = useState(null);
  
  const faqs = [
  {
    question: "Can ToxBox AI send multi-channel follow-ups?",
    answer:
      "Yes, it automates emails, SMS, LinkedIn messages, and website chat interactions.",
  },
  {
    question: "Is personalization automated?",
    answer: "Absolutely. AI tailors messages dynamically using lead data.",
  },
  {
    question: "Can I integrate it with my website?",
    answer: "Yes, ToxBox AI integrates with forms, CRM, and other sales tools.",
  },
  {
    question: "Is my lead data secure?",
    answer: "Yes, enterprise-grade security and GDPR-compliant.",
  },
];

 const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      {/* Hero Section */}
      <section className={styles.hero}>
        <div className={styles.imageWrapper}>
          <img src={illustration} className={styles.image}></img>

          <div className={styles.textOverlay}>
            <h1 className={styles.headline}>AI Lead Nurturing</h1>
            <p className={styles.subheadline}>
              ToxBox<span> AI’s Lead Nurturing </span> tool automates
              follow-ups, personalizes outreach, and boosts conversions.
              Transform your lead management today.
            </p>
          </div>
        </div>
      </section>

      {/* Second Section */}
      <section className={styles.secondSection}>
        <div className={styles.secondcontent}>
          <h2 className={styles.secondHeadline}>
            AI Lead Agent – Smarter Lead Nurturing with ToxBox AI
          </h2>
          <p className={styles.secondPara}>
            Automate personalized follow-ups, nurture leads at scale, and
            increase conversions with AI-driven workflows.
          </p>
          <button className={styles.cta}>Start Nurturing Leads Smarter</button>
        </div>
        
      </section>


      {/* Third Section */}
      <section className={styles.thirdSection}>
        {/* Left Section */}
        <div className={styles.thirdContent}>
          <h2 className={styles.thirdHeadline}>
            Stop Losing Leads to Manual Follow-Ups
          </h2>
          <p className={styles.thirdPara}>
            Most businesses struggle to stay on top of their leads. Slow or
            inconsistent follow-ups lead to missed opportunities and wasted
            marketing spend. <span> ToxBox AI’s Lead</span> ToxBox AI’s Lead
            Nurturing automates follow-ups, personalizes engagement, and ensures
            no lead is left behind.
          </p>
        </div>
        <div>
          <img src={ilustration1}></img>
        </div>
        <div className={styles.cards1}>
          <div className={styles.card1}>
            <p>70% of leads never convert due to delayed follow-ups</p>
          </div>
          <div className={styles.card1}>
            <p>Personalized follow-ups can increase conversions by 50–60%</p>
          </div>
          <div className={styles.card1}>
            <p>AI-powered sequences reduce manual effort by up to 80%</p>
          </div>
        </div>
      </section>




      {/* Fourth Section */}
      <section className={styles.fourthSection}>
        <div>
          <h1>Intelligent Lead Nurturing, Step by Step</h1>
        </div>
        <div className={styles.cards4}>
          <div className={styles.card4} data-step="Step 1">
            <p>
              Lead Capture & Segmentation – Sync leads from website, CRM, or ad
              campaigns. AI segments leads based on engagement and intent
            </p>
          </div>
          <div className={styles.card4} data-step="Step 2">
            <p>
              Automated Personalized Outreach – Emails, SMS, chat messages, and
              LinkedIn outreach. Dynamic personalization using lead data
            </p>
          </div>
          <div className={styles.card4} data-step="Step 3">
            <p>
              Smart Follow-Up Sequences – AI schedules follow-ups at optimal
              times. Adjusts messaging based on lead behavior
            </p>
          </div>
          <div className={styles.card4} data-step="Step 4">
            <p>
              Engagement Analytics & Optimization – Track opens, clicks,
              replies, and conversion likelihood. AI suggests improvements for
              higher engagement
            </p>
          </div>
          <div className={styles.card4} data-step="Step 5">
            <p>
              Continuous Nurturing – Ongoing engagement with dormant leads.
              Re-engage cold leads automatically
            </p>
          </div>
        </div>
        <div className={styles.successCase}>
          <div className={styles.successText}>
            <p>
              <span>Company X</span> improved conversion by <strong>3x</strong>{" "}
              using <span>ToxBox AI’s Lead Nurturing</span>, with automated
              sequences handling <strong>90% of follow-ups</strong>.
            </p>
          </div>
          <div className={styles.successImage}>
            <img src={ilustration2} alt="Success Case" />
          </div>
        </div>
      </section>


      {/* Fifth Section */}
      <section className={styles.fifthSection}>
        <div className={styles.fifthContent}>
          <h2>AI Features That Drive Lead Engagement</h2>
        </div>
        <div className={styles.cards5}>
          <div className={styles.card5}>
            <p>Dynamic Lead Segmentation – Prioritize high-value leads</p>
          </div>
          <div className={styles.card5}>
            <p>Multi-Channel Nurturing – Email, SMS, LinkedIn, Chat</p>
          </div>

          <div className={styles.card5}>
            <p>Automated Follow-Up Workflows – Set once, run continuously</p>
          </div>
          <div className={styles.card5}>
            <p>Behavioral Tracking – Engage leads based on actions</p>
          </div>
          <div className={styles.card5}>
            <p>
              CRM & Website Integration – Connect ToxBox AI to your ecosystem
            </p>
          </div>
          <div className={styles.card5}>
            <p>Analytics & Reporting – Monitor ROI and lead progression</p>
          </div>
        </div>
        <div className={styles.fifthtagline}>
          <h2>
            {" "}
            – Nurture leads automatically while focusing on closing deals
          </h2>
        </div>
      </section>

      {/* Sixth Section */}
      <section className={styles.sixSection}>
        <div className={styles.sixContent}>
          <h2>Why ToxBox AI Lead Nurturing Works</h2>
        </div>
        <div className={styles.cards6}>
          <div className={styles.card6}>
            <p>
              Time Savings – Automate repetitive follow-ups. Reduce manual
              effort by 80%
            </p>
          </div>
          <div className={styles.card6}>
            <p>
              "Higher Conversions – Engage leads consistently. Personalized
              messaging increases response rate
            </p>
          </div>

          <div className={styles.card6}>
            <p>
              Better Insights – AI recommends best times and channels. Analytics
              help optimize campaigns
            </p>
          </div>
          <div className={styles.card6}>
            <p>
              "Customer Retention – Keep leads warm until they’re ready to buy.
              Reduce lead drop-off rates.
            </p>
          </div>
        </div>
      </section>

    
      {/* Seventh Section */}
      <section className={styles.sevenSection}>
        <div className={styles.sevenContent}>
          <h2>Works Seamlessly with Your Tools</h2>
          <ul>
            <li>
              Supported Platforms: CRM (HubSpot, Salesforce, Zoho), Website
              forms, Email platforms, Chatbots
            </li>
            <li>
              Auto-sync leads, track engagement, and trigger automated sequences
            </li>
            <li>Custom workflows for your sales and marketing teams</li>
          </ul>
        </div>

        {/* Testimonial */}
        <div className={styles.sevenTestimonial}>
          “Company Y integrated ToxBox AI with HubSpot and increased follow-up
          efficiency by 60% within a month.”
        </div>

        {/* CTA */}
        <a href="#integrate" className={styles.ctaButton}>
          Integrate ToxBox AI Now
        </a>
      </section>



      {/* Eighth {/* Eighth Section */}
      <section className={styles.eightSection}>
        <div className={styles.eightContent}>
          <h2>Trusted by Businesses Worldwide</h2>
        </div>

        <div className={styles.testimonials}>
          <div className={styles.testimonialCard}>
            <img src={ilustration3} alt="FinTechCo Manager" />
            <p>
              “ToxBox AI completely changed how we nurture leads. Our engagement
              rate skyrocketed!”
            </p>
            <div className={styles.testimonialFooter}>
              Marketing Manager, FinTechCo
            </div>
          </div>

          <div className={styles.testimonialCard}>
            <img src={ilustration4} alt="TechSolutions Director" />
            <p>
              “Automated follow-ups saved us countless hours and improved
              conversions.”
            </p>
            <div className={styles.testimonialFooter}>
              Sales Director, TechSolutions
            </div>
          </div>
        </div>
      </section>

     
     {/* 9th section */}
      {/* FAQ Section */}
      <section className={styles.faqSection} id="faq">
        <h2 className={styles.faqHeadline}>Frequently Asked Questions</h2>
        <div className={styles.faqList}>
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`${styles.faqItem} ${
                activeIndex === index ? styles.active : ""
              }`}
            >
              <button
                className={styles.faqQuestion}
                onClick={() => toggleFAQ(index)}
              >
                {faq.question}
                <span>{activeIndex === index ? "−" : "+"}</span>
              </button>
              {activeIndex === index && (
                <div className={styles.faqAnswer}>{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* 10th Section */}
      <section className={styles.tenSection}>
        <div className={styles.tenContent}>
          <h2>Nurture Leads Smarter with ToxBox AI</h2>
          <p>
            Stop losing leads due to delayed follow-ups. Let ToxBox AI automate,
            personalize, and optimize your lead nurturing process. Close deals
            faster, save time, and boost revenue.
          </p>
          <button className={styles.ctaButton}>Get ToxBox AI Now</button>
        </div>
      </section>
    </>
  );
};

export default LeadNurturing;